export default __webpack_public_path__ + "static/media/mode-icon-fill.0a4badfd.svg";